import {HttpClient} from '@angular/common/http';
import {Component, OnDestroy} from '@angular/core';
import {Subscription} from 'rxjs';

@Component({
    selector: 'app-newcomers',
    templateUrl: './newcomers.component.html',
    styleUrls: ['./newcomers.component.scss'],
})
export class NewcomersComponent implements OnDestroy {
    subscriptions: Subscription[] = [];

    constructor(private http: HttpClient) {}

    ngOnDestroy(): void {
        this.subscriptions.forEach(e => e.unsubscribe());
    }
}
